// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button[data-active="true"] {
  color: var( --color-brand500 );
}

.listItem_K8aNP {
  cursor: pointer;
}

.rollover_DBZuE {
  background-color: var(--color-tableRollover);
}

.footer_A2X2u {
  padding: 5px 0;
}

.toolbar_xI2_R {
  justify-content: space-between !important;
  align-items: center !important;
  padding: 5px 0;
}

.toolbars_UVHus {
  min-height: 58px;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/dataViewers/list/DesktopListView.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["button[data-active=\"true\"] {\n  color: var( --color-brand500 );\n}\n\n.listItem {\n  cursor: pointer;\n}\n\n.rollover {\n  background-color: var(--color-tableRollover);\n}\n\n.footer {\n  padding: 5px 0;\n}\n\n.toolbar {\n  justify-content: space-between !important;\n  align-items: center !important;\n  padding: 5px 0;\n}\n\n.toolbars {\n  min-height: 58px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listItem": `listItem_K8aNP`,
	"rollover": `rollover_DBZuE`,
	"footer": `footer_A2X2u`,
	"toolbar": `toolbar_xI2_R`,
	"toolbars": `toolbars_UVHus`
};
export default ___CSS_LOADER_EXPORT___;
